import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { PermissionService } from 'services/permission.service';

export const CapabilitiesGuard = (route: ActivatedRouteSnapshot): boolean | UrlTree => {
	const router = inject(Router);
	const capabilityNameToCheck = route.data['capabilityName'];

	const hasPermission = PermissionService.hasPermission(capabilityNameToCheck);

	if (hasPermission) {
		return true;
	}

	if (route.routeConfig?.path === 'task') {
		return router.createUrlTree(['/403']);
	}

	return router.createUrlTree(['/']);
};
